// End card: HAR HAR MAHADEV — Trishul descends, text explodes, fades to black
import { useCurrentFrame, useVideoConfig, interpolate, Easing, AbsoluteFill, spring } from "remotion";
import { loadFont as loadMontserrat } from "@remotion/google-fonts/MontserratAlternates";
import { loadFont as loadNoto } from "@remotion/google-fonts/NotoSansDevanagari";

const { fontFamily: mont } = loadMontserrat("normal", { weights: ["900"], subsets: ["latin"] });
const { fontFamily: noto } = loadNoto("normal", { weights: ["700"], subsets: ["devanagari"] });

const TrishulFull: React.FC<{ glow: number }> = ({ glow }) => (
  <svg width="107" height="207" viewBox="0 0 203 392" fill="none">
    <defs>
      <linearGradient id="hgold" x1="0" y1="0" x2="1" y2="0">
        <stop offset="0%" stopColor="#8B5E0A" />
        <stop offset="30%" stopColor="#D4A030" />
        <stop offset="55%" stopColor="#FFF5A0" />
        <stop offset="75%" stopColor="#FFD700" />
        <stop offset="100%" stopColor="#8B5E0A" />
      </linearGradient>
      <filter id="hglow" x="-30%" y="-30%" width="160%" height="160%">
        <feGaussianBlur stdDeviation={2 + glow * 3} result="blur" />
        <feMerge><feMergeNode in="blur" /><feMergeNode in="SourceGraphic" /></feMerge>
      </filter>
    </defs>
    <g filter="url(#hglow)" fill="url(#hgold)" stroke="#7A5000" strokeWidth="0.8">
      <path d="M33.499,144.251c3.662-1.943,9.738-1.436,14.772,0.443c10.396-18.138,17.586-81.09-7.309-95.717c15.417,42.394-6.783,76.49-8.583,79.536l-1.114,1.678l-0.77,1.2C32.434,135.627,33.327,139.967,33.499,144.251z" />
      <path d="M152.59,143.94c4.398-0.919,9.115-1.308,12.162,0.308c0.21-5.238,1.496-11.057,4.456-15.503l-0.154-0.232c-1.802-3.046-24-37.142-8.584-79.536c-25.053,14.719-18.396,77.261-7.884,94.954L152.59,143.94z" />
      <path d="M99.301,0.088c-0.021,13.632-5.121,89.769-19.03,119.995l-0.816,1.81c0.324-0.011,1.201-0.07,1.525-0.07c6.682,0.015,13.681,2.289,18.766,7.109c4.964-4.706,12.894-6.789,19.436-6.906l-0.848-1.942C104.425,89.857,99.322,13.72,99.301,0.088z" />
      <path d="M192.981,205.221c-0.852-2.601-3.635-17.944-6.557-31.677c-1.246-5.87-13.908-44.277-0.488-44.313c-13.692-8.271-18.371,8.438-18.79,18.87c-4.964-2.634-14.366-2.616-19.591,2.38c-2.824,2.701-3.393,9.954-1.215,12.029c6.166-11.215,15.965,6.552,18.42,11.946c4.434,9.729,6.271,32.455-3.207,39.996c-12.093,9.625-30.44,1.15-44.426-10.643l-9.499,5.417c0.391,1.834,0.606,3.822,0.608,5.908c-0.004,4.316-0.905,8.235-2.439,11.177c-0.214,0.407-0.444,0.796-0.687,1.167c-0.055,0.084-0.113,0.16-0.169,0.242c-0.202,0.294-0.41,0.578-0.63,0.844c-0.055,0.065-0.11,0.128-0.166,0.192c-0.242,0.278-0.493,0.542-0.757,0.782c-0.036,0.034-0.073,0.068-0.109,0.102c-0.308,0.271-0.626,0.52-0.959,0.732h0.001c-0.948,0.607-1.998,0.972-3.15,0.983c-1.115-0.011-2.136-0.349-3.06-0.92l0,0c-0.337-0.208-0.659-0.454-0.969-0.723c-0.06-0.052-0.117-0.107-0.175-0.16c-0.247-0.226-0.484-0.469-0.712-0.729c-0.073-0.082-0.146-0.165-0.216-0.251c-0.21-0.254-0.411-0.524-0.604-0.806c-0.065-0.094-0.133-0.184-0.197-0.28c-0.244-0.375-0.478-0.766-0.693-1.177c-1.535-2.941-2.436-6.86-2.44-11.177c0.002-2.353,0.278-4.578,0.771-6.6l-9.19-5.191c-14.018,12.034-32.645,20.859-44.896,11.108c-9.475-7.541-7.639-30.267-3.207-39.996c2.457-5.394,12.255-23.161,18.421-11.946c2.176-2.075,1.608-9.328-1.217-12.029c-5.224-4.997-14.626-5.014-19.589-2.38c-0.42-10.432-5.1-27.141-18.791-18.87c13.418,0.036,0.758,38.443-0.491,44.313c-2.921,13.733-5.705,29.076-6.556,31.677c-0.908,2.77-1.59,4.088-5.361,7.082c2.862,3.139,4.91,7.863,5.816,9.951c2.866,6.609,2.959,29.955,20.896,37.252c32.638,13.279,50.169-27.006,59.392-28.898c5.418,15.303-10.312,33.072-10.312,33.072l6.433,4.622c0,0,16.885,81.185-6.433,118.187c-11.437,18.147,57.514,16.35,46.936,0c-23.618-36.502-6.433-118.187-6.433-118.187l6.433-4.251c0,0-15.393-18.181-10.144-33.523c10.059,3.403,30.145,41.37,59.047,28.979c17.797-7.633,18.028-30.643,20.896-37.25c0.905-2.09,2.955-6.814,5.815-9.953C194.572,209.311,193.889,207.993,192.981,205.221z" />
      <path d="M99.172,134.413c-10.139-14.514-39.866-11.587-36.586,9.843c18.671-15.452,35.253,19.54,18.406,31.885c3.329,0.551,12.355,11.666-3.736,20.307l14.919,8.288c0.121-0.263,0.24-0.528,0.37-0.777c1.52-2.907,3.774-5.019,6.627-5.046c2.85,0.027,5.105,2.139,6.625,5.046c0.166,0.318,0.321,0.653,0.473,0.994l14.527-8.504c-15.021-10.12-6.777-19.756-3.447-20.307c-16.846-12.345-0.266-47.337,18.406-31.885C139.036,122.826,109.309,119.898,99.172,134.413z" />
    </g>
  </svg>
);

export const HarHarMahadev: React.FC = () => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();

  // Background fades from transparent to dark
  const bgOpacity = interpolate(frame, [0, Math.round(0.5 * fps)], [0, 1], { extrapolateRight: "clamp", extrapolateLeft: "clamp" });

  // Trishul drops from top with spring
  const trishulSpring = spring({ frame, fps, config: { damping: 10, stiffness: 70 }, durationInFrames: Math.round(1.2 * fps) });
  const trishulY = interpolate(trishulSpring, [0, 1], [-253, 0]);
  const trishulScale = interpolate(trishulSpring, [0, 1], [1.2, 1]);

  // Ripple waves — start gaps increase (0.2→0.3→0.4→0.5s), expansion duration increases (0.7→0.85→1.0→1.15→1.3s)
  const wave1 = interpolate(frame, [Math.round(1.10 * fps), Math.round(1.80 * fps)], [0, 1], { extrapolateRight: "clamp", extrapolateLeft: "clamp", easing: Easing.bezier(0.0, 0.0, 0.3, 1) });
  const wave2 = interpolate(frame, [Math.round(1.30 * fps), Math.round(2.15 * fps)], [0, 1], { extrapolateRight: "clamp", extrapolateLeft: "clamp", easing: Easing.bezier(0.0, 0.0, 0.3, 1) });
  const wave3 = interpolate(frame, [Math.round(1.60 * fps), Math.round(2.60 * fps)], [0, 1], { extrapolateRight: "clamp", extrapolateLeft: "clamp", easing: Easing.bezier(0.0, 0.0, 0.3, 1) });
  const wave4 = interpolate(frame, [Math.round(2.00 * fps), Math.round(3.15 * fps)], [0, 1], { extrapolateRight: "clamp", extrapolateLeft: "clamp", easing: Easing.bezier(0.0, 0.0, 0.3, 1) });
  const wave5 = interpolate(frame, [Math.round(2.50 * fps), Math.round(3.80 * fps)], [0, 1], { extrapolateRight: "clamp", extrapolateLeft: "clamp", easing: Easing.bezier(0.0, 0.0, 0.3, 1) });

  // Trishul pulse glow (breathing)
  const pulse = Math.sin(frame * 0.25) * 0.5 + 0.5;

  // "HAR HAR" — slow fade in from left
  const hh1X = interpolate(frame, [Math.round(1.2 * fps), Math.round(3.2 * fps)], [-40, 0], {
    extrapolateRight: "clamp", extrapolateLeft: "clamp",
    easing: Easing.bezier(0.25, 0.1, 0.25, 1),
  });
  const hh1Opacity = interpolate(frame, [Math.round(1.2 * fps), Math.round(3.0 * fps)], [0, 1], { extrapolateRight: "clamp", extrapolateLeft: "clamp" });

  // "MAHADEV" — slow fade in from right
  const hh2X = interpolate(frame, [Math.round(1.6 * fps), Math.round(3.6 * fps)], [60, 0], {
    extrapolateRight: "clamp", extrapolateLeft: "clamp",
    easing: Easing.bezier(0.25, 0.1, 0.25, 1),
  });
  const hh2Opacity = interpolate(frame, [Math.round(1.6 * fps), Math.round(3.4 * fps)], [0, 1], { extrapolateRight: "clamp", extrapolateLeft: "clamp" });

  // Hindi text fades in below
  const hindiOpacity = interpolate(frame, [Math.round(3.4 * fps), Math.round(4.6 * fps)], [0, 1], { extrapolateRight: "clamp", extrapolateLeft: "clamp" });

  // Divider lines extend
  const lineW = interpolate(frame, [Math.round(3.2 * fps), Math.round(4.4 * fps)], [0, 100], {
    extrapolateRight: "clamp", extrapolateLeft: "clamp",
    easing: Easing.bezier(0.4, 0, 0.2, 1),
  });

  // Fade out in last 1.5s
  const fadeOut = interpolate(frame, [Math.round(5.5 * fps), Math.round(7 * fps)], [1, 0], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });

  return (
    <AbsoluteFill style={{ overflow: 'hidden' }}>
      <div style={{ position: 'absolute', inset: 0, opacity: fadeOut }}>
      {/* Dark bg */}
      <div style={{
        position: "absolute", inset: 0, opacity: bgOpacity,
        background: "radial-gradient(ellipse at 50% 30%, #1a0800 0%, #0a0400 50%, #000 100%)",
      }} />

      {/* Ripple waves — 5 staggered rings cascading outward */}
      <div style={{
        position: "absolute", left: "50%", top: "36%",
        width: 267, height: 267, borderRadius: "50%",
        border: `2px solid rgba(255,215,0,${(1 - wave1) * 0.7})`,
        transform: `translate(-50%, -50%) scale(${0.1 + wave1 * 3.2})`,
        opacity: 1 - wave1,
      }} />
      <div style={{
        position: "absolute", left: "50%", top: "36%",
        width: 200, height: 200, borderRadius: "50%",
        border: `1.5px solid rgba(255,150,0,${(1 - wave2) * 0.5})`,
        transform: `translate(-50%, -50%) scale(${0.1 + wave2 * 4.0})`,
        opacity: 1 - wave2,
      }} />
      <div style={{
        position: "absolute", left: "50%", top: "36%",
        width: 267, height: 267, borderRadius: "50%",
        border: `2px solid rgba(255,215,0,${(1 - wave3) * 0.65})`,
        transform: `translate(-50%, -50%) scale(${0.1 + wave3 * 3.2})`,
        opacity: 1 - wave3,
      }} />
      <div style={{
        position: "absolute", left: "50%", top: "36%",
        width: 220, height: 220, borderRadius: "50%",
        border: `1.5px solid rgba(255,180,0,${(1 - wave4) * 0.55})`,
        transform: `translate(-50%, -50%) scale(${0.1 + wave4 * 3.6})`,
        opacity: 1 - wave4,
      }} />
      <div style={{
        position: "absolute", left: "50%", top: "36%",
        width: 267, height: 267, borderRadius: "50%",
        border: `1px solid rgba(255,215,0,${(1 - wave5) * 0.4})`,
        transform: `translate(-50%, -50%) scale(${0.1 + wave5 * 3.2})`,
        opacity: 1 - wave5,
      }} />

      {/* Trishul — center, upper half */}
      <div style={{
        position: "absolute", left: "50%", top: "18%",
        transform: `translateX(-50%) translateY(${trishulY}px) scale(${trishulScale})`,
        filter: `drop-shadow(0 0 ${5 + pulse * 8}px rgba(255,180,0,${0.4 + pulse * 0.3}))
                 drop-shadow(0 5px 16px rgba(0,0,0,0.8))`,
      }}>
        <TrishulFull glow={pulse * 0.8} />
      </div>

      {/* Text block — lower half */}
      <div style={{ position: "absolute", bottom: "22%", left: 0, right: 0, display: "flex", flexDirection: "column", alignItems: "center", gap: 3 }}>

        {/* HAR HAR | MAHADEV */}
        <div style={{ display: "flex", alignItems: "baseline", gap: 16 }}>
          <span style={{
            opacity: hh1Opacity,
            transform: `translateX(${hh1X}px)`,
            display: "inline-block",
            fontSize: 64, fontWeight: 900, fontFamily: mont,
            color: "#fff", letterSpacing: 8,
            textShadow: "0 0 27px rgba(255,150,0,0.4), 0 3px 11px rgba(0,0,0,0.9)",
          }}>HAR HAR</span>
          <span style={{
            opacity: hh2Opacity,
            transform: `translateX(${hh2X}px)`,
            display: "inline-block",
            fontSize: 64, fontWeight: 900, fontFamily: mont,
            color: "#FFD700", letterSpacing: 8,
            textShadow: "0 0 27px rgba(255,215,0,0.5), 0 3px 11px rgba(0,0,0,0.9)",
          }}>MAHADEV</span>
        </div>

        {/* Divider */}
        <div style={{
          width: `${lineW}%`, maxWidth: 533, height: 1,
          background: "linear-gradient(90deg, transparent, rgba(255,215,0,0.5), transparent)",
          margin: "4px 0",
        }} />

        {/* Hindi */}
        <div style={{ opacity: hindiOpacity, display: "flex", gap: 13 }}>
          {["हर", "हर", "महादेव"].map((word, i) => (
            <span key={i} style={{
              display: "inline-block",
              color: "rgba(255,215,0,0.8)", fontSize: 24, fontFamily: noto, fontWeight: 700,
            }}>{word}</span>
          ))}
        </div>
      </div>
      </div>
    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
